"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storage = exports["default"] = void 0;
var _amazonCognitoIdentityJs = require("amazon-cognito-identity-js");
var storage = exports.storage = new _amazonCognitoIdentityJs.CookieStorage({
  secure: process.env.REACT_APP_COOKIE_SECURE === 'true',
  domain: process.env.REACT_APP_COOKIE_DOMAIN,
  path: '/',
  expires: 365
});
var poolData = {
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  Storage: storage
};
var userPool = new _amazonCognitoIdentityJs.CognitoUserPool(poolData);
var _default = exports["default"] = userPool;